import { createServiceURL } from 'shared/utils'

const mediaLibraryModule = 'media_library'
const getCategoriesEndpoint = 'media_categories'

export const categoriesEndpoint = createServiceURL(
  mediaLibraryModule,
  getCategoriesEndpoint
)
